<script lang="ts">
  interface Props {
    children?: import('svelte').Snippet;
  }

  let { children }: Props = $props();
</script>

<div class="px-gno-page pb-gno-page">
  {@render children?.()}
</div>
